import React from 'react';
import styled from 'styled-components';
import Content from 'gatsby-theme-core/src/components/content';
import Stars from '../../../../components/styled-stars';

const ReviewPreview = ({
  className,
  reviewerName,
  content,
  score,
  maximumScore,
}) => (
  <article className={className}>
    <Stars
      $score={score}
      $maximumScore={maximumScore}
    />
    <Name>{reviewerName}</Name>
    <Content $content={content} />
  </article>
);

const Name = styled.strong`
  display: block;
  padding-bottom: .5rem;
  font-size: 1.25rem;
  line-height: 150%;
`;

export default styled(ReviewPreview)`
  border: 1px solid ${({ theme }) => theme.primaryColor};
  padding: 1rem;
`;
